const CraftIdentityMatchesSearch = ({
  updateMatchesRef,
  searchMatchesInput,
  setSearchMatchesInput,
}) => {
  const inputHandler = (e) => {
    updateMatchesRef();
    setSearchMatchesInput(e.target.value);
  };

  return (
    <div className="card-details__search-wrapper" onClick={(e) => e.stopPropagation()}>
      <p className="card-details__search">
        <input
          type="text"
          placeholder="Search..."
          value={searchMatchesInput}
          onInput={inputHandler}
          className="card-details__search-input"
        />
        {
          searchMatchesInput !== '' &&
          <button
            className="card-details__search-reset"
            onClick={() => setSearchMatchesInput("")}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 9L9 15M15 15L9 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="#ffffff"
                strokeWidth="1.4"
                strokeLinecap="square"
              />
            </svg>
          </button>
        }
      </p>
    </div>
  );
};

export default CraftIdentityMatchesSearch;
